<template>
	<div class="container">
		<div
				class="pay_info"
				style="height: auto"
		>
			<div class="money" v-if="parseFloat(money)">
				<span>¥</span>{{ parseFloat(money).toFixed(2) }}
			</div>
			<div class="paystatetxt">支付成功</div>
			<div class="btnlist">
				<div @click="goApp()" class="btn" >前往APP查看升级权益</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { isWeixin, fenxiang, downloadpath } from '../../assets/common/js/config'
	export default {
	  name: "vipgiftbagpayResult",
	  data () {
	  	return {
		  money: this.$route.query.money ? this.$route.query.money : 0
		}
	  },
	  methods: {
		goApp () {
			window.location = downloadpath
		}
	  },
	  mounted () {
	  	if (isWeixin()) {
	  		fenxiang({path: 'vipgiftbagpayResult'})
		}
	  }
	}
</script>

<style scoped lang="scss">
	.container {
		height: calc(100vh);
		background: #fff;
		.pay_info {
			padding-top: 0.24rem;
			.money {
				text-align: center;
				color: #333333;
				font-size: 0.37rem;
				padding-top: 0.22rem;
				font-weight: 600;
				span {
					font-size: 0.23rem;
				}
			}
			.paystatetxt {
				font-size: 0.16rem;
				color: #333;
				text-align: center;
				margin-top: 0.05rem;
			}
			.btnlist {
				margin-top: 0.32rem;
				padding-bottom: 0.33rem;
				display: flex;
				align-items: center;
				justify-content: center;
				.btn {
					border-radius: 0.14rem;
					border: 0.005rem solid rgba(96, 96, 96, 1);
					padding: 0.05rem 0.11rem;
					font-size: 0.12rem;
					text-align: center;
					color: #262626;
				}
				.redbtn {
					background: #fc0324;
					color: #fff;
					border-color: #fc0324;
				}
				.leftsp {
					margin-left: 0.25rem;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/upgradeVIP/vipgiftbagpayResult.vue